/**
 * Extract {{ token }} placeholders from a string (whitespace inside braces allowed).
 * Returns unique inner names matching [a-zA-Z0-9_.]+
 */
export function extractMergeTokens(str) {
  if (!str || typeof str !== 'string') return [];
  const re = /\{\{\s*([a-zA-Z0-9_.]+)\s*\}\}/g;
  const found = [];
  const seen = new Set();
  let m;
  // eslint-disable-next-line no-cond-assign
  while ((m = re.exec(str)) !== null) {
    const name = m[1];
    if (!seen.has(name)) {
      seen.add(name);
      found.push(name);
    }
  }
  return found;
}

/**
 * If allowlist is non-empty, every token in subject+body must be in allowlist (as names or {{name}} form).
 * allowlist entries can be "name" or "{{name}}".
 */
export function validateMergeAgainstAllowlist(subject, body, allowlist) {
  const list = Array.isArray(allowlist) ? allowlist.map((s) => String(s).trim()).filter(Boolean) : [];
  if (!list.length) {
    return { ok: true, invalidTokens: [] };
  }
  const allowed = new Set();
  list.forEach((entry) => {
    const m = entry.match(/^\{\{\s*([a-zA-Z0-9_.]+)\s*\}\}$/);
    if (m) {
      allowed.add(m[1]);
    } else {
      allowed.add(entry.replace(/^\{\{|\}\}$/g, '').trim());
    }
  });
  const combined = `${subject || ''}\n${body || ''}`;
  const used = extractMergeTokens(combined);
  const invalidTokens = used.filter((t) => !allowed.has(t));
  return {
    ok: invalidTokens.length === 0,
    invalidTokens,
  };
}
